import { HiOutlineExclamationTriangle } from "react-icons/hi2";
import { useState } from "react";
import { useUser } from "../../hooks";
import { FormButton } from "../../ui";
import { ByokKeyModal } from "./byok-key-modal";
import "./byok-key.scss";

/**
 * Warns that the connected OpenRouter key stopped working. The backend then
 * silently falls back to the plan's AI credits, so without this the user only
 * notices when the credit pool runs dry.
 */
export const ByokKeyAlert = (): JSX.Element | null => {
  const { currentUser } = useUser();
  const [showModal, setShowModal] = useState(false);
  const byok = currentUser?.byok;

  if (!byok?.enabled || !byok.has_key) return null;
  if (byok.status !== "invalid" && byok.status !== "no_credits") return null;

  const reason =
    byok.status === "no_credits"
      ? "Your OpenRouter key has no balance"
      : "Your OpenRouter key failed";

  return (
    <>
    <div className="byok-alert">
      <HiOutlineExclamationTriangle size={18} />
      <span className="byok-alert__text">
        <strong>{reason}</strong> - AI now runs on your plan credits.
      </span>
      <FormButton
        theme="green-light"
        className="byok-alert__button"
        onClick={() => {
          // antd hands focus back on close - avoid a lingering focus ring
          (document.activeElement as HTMLElement | null)?.blur();
          setShowModal(true);
        }}
      >
        Update
      </FormButton>
    </div>
    {/* Fix the key in place instead of sending the user to Tools & Apps */}
    <ByokKeyModal open={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};
